import { DecimalPipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";

/**
 * Generated class for the ConversionInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: "conversion-input",
  templateUrl: "conversion-input.html",
})
export class ConversionInputComponent implements OnInit {
  // Configuration properties

  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() group: FormGroup;
  @Input() config;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  placeholder: string = "";
  innerGroup: FormGroup;
  disabled: boolean = false;
  readonly: boolean = false;
  max: number;
  min: number;
  required: boolean;
  aUnit: string;
  bUnit: string;
  abConversion: number;
  baConversion: number;
  aLastConverted: number;
  bLastConverted: number;
  precision: string;

  constructor(
    public formBuilder: FormBuilder,
    public decimalPipe: DecimalPipe,
    public dataService: AssessmentDataService
  ) {
    // console.log('Hello ConversionInputComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Group: " );
    // console.log( this.group );
    // console.log( "Conversion Input config: " );
    // console.log( this.config );

    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;
    if (this.config.placeholder) {
      this.placeholder = this.config.placeholder;
    }

    if (
      !this.config.rules ||
      !this.config.rules.aUnit ||
      !this.config.rules.bUnit ||
      !this.config.rules.conversionFactorAB
    ) {
      console.error("Can't make conversion component without units!");
      return;
    }
    this.aUnit = this.config.rules.aUnit;
    this.bUnit = this.config.rules.bUnit;

    this.abConversion = this.config.rules.conversionFactorAB;
    this.baConversion = 1 / this.abConversion;

    this.precision = this.config.rules.precision || "1.0-6";

    // Inner form state
    this.innerGroup = this.formBuilder.group({});
    this.innerGroup.addControl(this.aUnit, this.formBuilder.control(""));
    this.innerGroup.addControl(this.bUnit, this.formBuilder.control(""));
    // Outer form state
    this.group.addControl(this.id, this.formBuilder.control({}));
    let selfControl = this.group.controls[this.id];

    this.setValidation();
    // console.log( "POST form controls:", this.innerGroup.controls );

    this.innerGroup.controls[this.aUnit].valueChanges.subscribe((data) => {
      // console.log( "A value changed: ", data );
      if (this.aLastConverted != data) {
        if (data == null || data === "") {
          this.innerGroup.controls[this.bUnit].setValue(null);
        } else {
          var converted = +this.decimalPipe
            .transform(this.abConversion * data, this.precision)
            .replace(/\,/g, "");
          this.bLastConverted = converted;
          this.innerGroup.controls[this.bUnit].setValue(converted);
        }
      }
      this.syncInnerValue();
    });
    this.innerGroup.controls[this.bUnit].valueChanges.subscribe((data) => {
      // console.log( "B value changed: ", data );
      if (this.bLastConverted != data) {
        if (data == null || data === "") {
          this.innerGroup.controls[this.aUnit].setValue(null);
        } else {
          var converted = +this.decimalPipe
            .transform(this.baConversion * data, this.precision)
            .replace(/\,/g, "");
          this.aLastConverted = converted;
          this.innerGroup.controls[this.aUnit].setValue(converted);
        }
      }
      this.syncInnerValue();
    });

    selfControl.valueChanges.subscribe((data) => {
      // console.log( "Outer val changed: ", data );
      this.disabled = selfControl.disabled;

      if (this.disabled) {
        var validators = [];
        var aUnitValidators: ValidatorFn = Validators.compose(validators);
        this.innerGroup.controls[this.aUnit].setValidators(aUnitValidators);
      } else {
        this.setValidation();
      }

      let aControl = this.innerGroup.controls[this.aUnit];
      let bControl = this.innerGroup.controls[this.bUnit];
      if (data === null) {
        aControl.setValue(null);
        bControl.setValue(null);
      } else if (+aControl.value != data[this.aUnit]) {
        aControl.setValue(data[this.aUnit]);
      }
    });

    let ctrlValue = null;
    if (
      this.group.controls[this.id].valueOf() !== undefined &&
      this.group.controls[this.id].valueOf() !== null
    ) {
      ctrlValue = this.group.controls[this.id].valueOf();
    }
    if (
      ctrlValue !== undefined &&
      ctrlValue !== null &&
      ctrlValue["value"] !== undefined &&
      ctrlValue["value"] !== null &&
      ctrlValue["value"][this.aUnit] !== undefined &&
      ctrlValue["value"][this.aUnit] !== null
    ) {
      let initialA =
        this.group.controls[this.id].valueOf()["value"][this.aUnit];
      let initialB =
        this.group.controls[this.id].valueOf()["value"][this.bUnit];
      this.innerGroup.controls[this.aUnit].setValue(initialA, {
        emitEvent: false,
      });
      this.innerGroup.controls[this.bUnit].setValue(initialB, {
        emitEvent: false,
      });
    }
    this.syncInnerValue();
  }

  setValidation() {
    var validators = [];
    if (this.config.rules) {
      if (this.config.rules.required) {
        this.required = this.config.rules.required;
        validators.push(Validators.required);
      }

      if (this.config.rules.min !== undefined) {
        this.min = this.config.rules.min;
        validators.push(Validators.min(this.min));
      }

      if (this.config.rules.max !== undefined) {
        this.max = this.config.rules.max;
        validators.push(Validators.max(this.max));
      }
    }

    var aUnitValidators: ValidatorFn = Validators.compose(validators);
    this.innerGroup.controls[this.aUnit].setValidators(aUnitValidators);
  }

  ngAfterViewInit(): void {
    this.syncErrorState();

    // Errors can get lost when manually set
    // This is an overzealous approach to guarantee they get maintained
    this.innerGroup.valueChanges.subscribe((data) => {
      this.syncErrorState();
    });
  }

  syncInnerValue(): void {
    let val = {};
    val[this.aUnit] = +this.innerGroup.controls[this.aUnit].value;
    val[this.bUnit] = +this.innerGroup.controls[this.bUnit].value;
    // console.log( "setting inner val: ", val );
    this.group.controls[this.id].setValue(val);
  }

  syncErrorState(): void {
    // console.log( "Syncing error state: ", this.innerGroup.controls[this.aUnit].errors );
    this.group.controls[this.id].setErrors(
      this.innerGroup.controls[this.aUnit].errors
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/conversion-input/conversion-input.ts